import * as React from "react";

import ModalBase from "./ModalBase";
import { NewUser } from "../model/model";
import { useModal } from "../context/ModalContext";

interface ModalProps {
  onConfirm: (newUser: NewUser) => void;
}

export const NewUserModal: React.FC<ModalProps> = ({ onConfirm }) => {
  const [newUser, setNewUser] = React.useState<NewUser>({
    name: "",
    email: "",
    sendEmail: false,
  });
  const { hideModal } = useModal();

  const handleConfirm = () => {
    onConfirm(newUser);
    hideModal();
  };

  const handleCancel = () => {
    hideModal();
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewUser({ ...newUser, [e.target.name]: e.target.value });
  };

  return (
    <ModalBase
      header="New User"
      body={
        <>
          <div className="form-field">
            <label>Name</label>
            <input type="text" name="name" onChange={onChange} />
          </div>
          <div className="form-field">
            <label>Email</label>
            <input type="email" name="email" onChange={onChange} />
          </div>

          <div className="form-field">
            <input
              type="checkbox"
              name="sendEmail"
              onChange={() =>
                setNewUser({ ...newUser, sendEmail: !newUser.sendEmail })
              }
            />
            Send email with login instructions
          </div>
        </>
      }
      footer={
        <>
          <button
            className="loa-button loa-button-secondary"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            className="loa-button loa-button-primary"
            onClick={handleConfirm}
          >
            Confirm
          </button>
        </>
      }
    />
  );
};
